import { useEffect } from "react";

const SITE_URL = "https://www.theroyalmahaveerroadlines.in";

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    if (selector.includes('property="')) el.setAttribute("property", selector.match(/property="([^"]+)"/)[1]);
    if (selector.includes('name="')) el.setAttribute("name", selector.match(/name="([^"]+)"/)[1]);
    if (selector.includes('rel="')) el.setAttribute("rel", selector.match(/rel="([^"]+)"/)[1]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function useSeo(title, description) {
  useEffect(() => {
    const fullTitle = `${title} | The Royal Mahaveer Roadlines Pvt Ltd`;
    const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
    const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
  }, [title, description]);
}
